import { Box, styled, Table, TableBody, tableCellClasses, TableContainer, TableHead, TableRow, Typography, TableCell, IconButton, Button, TablePagination, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Domains from '../../global/constants/domain';
import { Download, VisibilityOutlined } from '@mui/icons-material';
import { ApiGetChecklistPdf, ApiGetChecklistSubmissionList } from '../../apiService/Core/Apicall';
import storage from '../../utils/storage';
import { toast } from 'react-toastify';
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../global/config/Reducer';
import dayjs from 'dayjs';
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice';

function SubmittedChecklistList() {

    const [submittedChecklist, setSubmittedChecklist] = useState<any>([])
    const navigate = useNavigate()
    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const dispatch = useDispatch()
    const [month, setmonth] = useState<any>(dayjs(selectedMonth))
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);


    const getIconColorByDomain = () => {
        const domain = window.location.hostname;

        if (domain.includes(Domains.ALDI)) return '#001F79';
        if (domain.includes(Domains.BLOOMS)) return '#1C2B90';
        if (domain.includes(Domains.MM)) return '#ADB792';

        return '#ADB792';
    };
    const primary_color = getIconColorByDomain()


    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: primary_color,
            color: theme.palette.common.white,
            padding: "10px 20px"
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            padding: " 10px 20px",
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(even)': {
            backgroundColor: `${primary_color}1A`,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));


    const GetSubmittedChecklistList = async () => {
        try {
            const checkListType = storage.getItem('dashboardCheckListType') || "BUSINESS";
            const data = `?month=${dayjs(month).month() + 1}
    &year=${dayjs(month).year()}
    &clientEntityId=${storage.getItem("clientEntityId")}
    &offset=${page * rowsPerPage}
    &limit=${rowsPerPage}
    &status=SUBMITTED&isRecentNeeded=true${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}&checkListType=${checkListType}`;
            const res = await ApiGetChecklistSubmissionList(data)
            if (res?.status || res?.success) {
                setSubmittedChecklist(res?.data || [])
                setTotalCount(res?.totalCount || res?.count || 0);
            }
        } catch (error: any) {
            toast.error(error)
        }

    }

    useEffect(() => {
        GetSubmittedChecklistList()
    }, [month, page, rowsPerPage])

    useEffect(() => {
        setmonth(dayjs(selectedMonth))
        setPage(0)
    }, [selectedMonth])

    const handleChangePage = (
        event: unknown,
        newPage: number
    ) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const downloadChecklist = async (id: string | number, name: string, areaId?: string | number) => {
        const checkListType = storage.getItem('dashboardCheckListType') || "BUSINESS";
        const checkAreaId = areaId || storage.getItem('areaId');
        const areaIdParam = (checkListType === "AREA_MANAGER" && checkAreaId && checkAreaId !== "undefined" && checkAreaId !== "null") ? `&areaId=${checkAreaId}` : '';
        const data = `?businessCheckListSubmissionId=${id}&clientEntityId=${storage.getItem('clientEntityId')}&checkListType=${checkListType}${areaIdParam}`;

        try {
            const response = await ApiGetChecklistPdf(data);

            const blob = new Blob([response.data], { type: 'application/pdf' });

            if (blob.size === 0) {
                throw new Error("Empty PDF file.");
            }
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${name}_${month?.month() + 1}_${month?.year()}.pdf`; // custom file name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // setPdfUrl(url); // this will trigger rendering the PDF
        } catch (error: any) {
            console.log(error)
        }
    };

    return (
        <Box>
            <Box className='d-flex align-items-center gap-3 justify-content-end mb-3'>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker value={month}
                        sx={{ maxWidth: "120px" }}
                        views={['month', 'year']}
                        format="MMM-YY"
                        label='Month'
                        onChange={(e: any) => {
                            const isoString = e?.startOf('month').toISOString();
                            dispatch(setSelectedMonth(isoString));
                        }}
                        slots={{
                            openPickerIcon: ArrowDropDownIcon,
                        }}
                    />
                </LocalizationProvider>
                <Button className='btn-main' onClick={() => { navigate('/maindashboard/Checklist/checklist-list') }}>Manage Checklist</Button>
            </Box>
            <TableContainer>
                <Table>
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell><Typography variant='body1' className='fw-bold'>Checklist Name</Typography></StyledTableCell>
                            <StyledTableCell><Typography variant='body1' className='fw-bold'>Site Name</Typography></StyledTableCell>
                            <StyledTableCell><Typography variant='body1' className='fw-bold'>Submitted At</Typography></StyledTableCell>
                            <StyledTableCell><Typography variant='body1' className='fw-bold'>Submitted By</Typography></StyledTableCell>
                            <StyledTableCell><Typography variant='body1' className='fw-bold'>Photos</Typography></StyledTableCell>
                            <StyledTableCell><Typography variant='body1' className='fw-bold'>Status</Typography></StyledTableCell>
                            <StyledTableCell><Typography variant='body1' className='fw-bold'>Actions</Typography></StyledTableCell>
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {
                            submittedChecklist?.map((item: any, index: number) => (
                                <StyledTableRow key={index}>
                                    <StyledTableCell>{item?.businessCheckListTitle}</StyledTableCell>
                                    <StyledTableCell>{item?.venueName}</StyledTableCell>
                                    <StyledTableCell>{dayjs(item?.submittedOn).fromNow()}</StyledTableCell>
                                    <StyledTableCell>{item?.userName}</StyledTableCell>
                                    <StyledTableCell>{item?.attachedImageCount} photos</StyledTableCell>
                                    <StyledTableCell>
                                        <Typography variant='caption' className='px-2 border-10 fw-bold' sx={{ color: item?.resultStatus === "PASS" ? "var(--primary-color)" : "#BF613B" }} bgcolor={item?.resultStatus === "PASS" ? 'var(--primary-light-main-color)' : "#BF613B2A"}>{item?.resultStatus}</Typography>
                                    </StyledTableCell>
                                    <StyledTableCell >
                                        <Tooltip title='View Checklist'>
                                            <IconButton onClick={() => { navigate(`/maindashboard/checklist/checklist-list/checklist-questions/${item?.businessCheckListSubmissionId}`) }} className='m-0 p-0'>
                                                <VisibilityOutlined />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title='Download pdf' className='ms-2'>
                                            <IconButton onClick={() => { downloadChecklist(item?.businessCheckListSubmissionId, item?.businessCheckListTitle, item?.areaId) }} className='m-0 p-0'>
                                                <Download className='text-main' />
                                            </IconButton>
                                        </Tooltip>

                                    </StyledTableCell>
                                </StyledTableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                component="div"
                count={totalCount}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
            />
        </Box>
    )
}

export default SubmittedChecklistList
